export const ENQUIRIES_GET = 'ENQUIRIES_GET';
export const ENQUIRIES_GET_RESPONSE = 'ENQUIRIES_GET_RESPONSE';
